import React from 'react'

import { Spacing } from '@interco/inter-ui/components/Spacing'
import { Text } from '@interco/inter-ui/components/Text'
import IconCopy from '@inter/icons/orangeds/LG/copy'

import * as S from './styles'

interface ListItemPixProps {
  title: string
  keyPix: string
  onCopyKey: () => void
}
export const ListItemPix = ({ title, keyPix, onCopyKey }: ListItemPixProps) => (
  <S.Container id={keyPix} onClick={onCopyKey}>
    <div>
      <Text variant="body-3" colorWeight={500} bold>
        {title}
      </Text>
      <Spacing mb="xxxs" />
      <Text variant="caption-1">{keyPix}</Text>
    </div>
    <IconCopy width={24} height={24} data-testid="left-icon" />
  </S.Container>
)
